import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.colors.lightBlue,
  },
  ablenkerRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: theme.spacings.sm,
  },
  ablenkerLabel: {
    color: theme.colors.darkestGrey,
    fontSize: theme.fontSizes.base,
    fontWeight: '600',
  },
  innerList: {
    width: '100%',
    flexDirection: 'column',
  },
});
